// extracted by mini-css-extract-plugin
export var centerText = "_b3-8";
export var container = "_b3-0";
export var doughnutContainer = "_b3-7";
export var legend = "_b3-a";
export var legendItemColorDisplay = "_b3-b";
export var legendItemLabel = "_b3-d";
export var legendItemValue = "_b3-c";
export var lg = "_b3-5";
export var maxWidth = "_b3-9";
export var md = "_b3-4";
export var responsive = "_b3-6";
export var sm = "_b3-3";
export var xs = "_b3-2";
export var xxs = "_b3-1";